/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FavritApp = {
    EPOS_APP_DIRECT_SALE: 'EPOS_APP_DIRECT_SALE',
    EPOS_APP_OPEN_BILL: 'EPOS_APP_OPEN_BILL',
    GUEST_APP: 'GUEST_APP',
    UNIBILL_APP: 'UNIBILL_APP',
    ADMIN_APP: 'ADMIN_APP',
    SUBSIDY: 'SUBSIDY'
} as const;
export type FavritApp = typeof FavritApp[keyof typeof FavritApp];


export function instanceOfFavritApp(value: any): boolean {
    for (const key in FavritApp) {
        if (Object.prototype.hasOwnProperty.call(FavritApp, key)) {
            if (FavritApp[key as keyof typeof FavritApp] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FavritAppFromJSON(json: any): FavritApp {
    return FavritAppFromJSONTyped(json, false);
}

export function FavritAppFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavritApp {
    return json as FavritApp;
}

export function FavritAppToJSON(value?: FavritApp | null): any {
    return value as any;
}

export function FavritAppToJSONTyped(value: any, ignoreDiscriminator: boolean): FavritApp {
    return value as FavritApp;
}

